import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addBeneficiary: 'Add a new beneficiary',
    beneficiaries: 'Beneficiaries',
    beneficiary: 'Beneficiary',
    description: 'Add and manage your beneficiaries, send transfers',
    unknownError: 'Oops! There was an unknown error',
  },
  fr: {
    addBeneficiary: 'Ajouter un bénéficiaire',
    beneficiaries: 'Bénéficiaires',
    beneficiary: 'Bénéficiaire',
    description: 'Ajoutez et gérez vos bénéficiaires, faites des virements',
    unknownError: 'Oups! Une erreur inconnue est survenue',
  },
} as const);

export default locales;
